document.addEventListener("DOMContentLoaded", function () {
  var modal = document.getElementById("kg-search-modal");
  if (!modal) return;

  // Keep overlay above theme stacking contexts (header z-index: 100)
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  var input = modal.querySelector("[data-kg-search-input]");
  var form = modal.querySelector("[data-kg-search-form]");
  var emptyEl = modal.querySelector("[data-kg-search-empty]");
  var resultsEl = modal.querySelector("[data-kg-search-results]");
  var statusEl = modal.querySelector("[data-kg-search-status]");
  var openTriggers = document.querySelectorAll("[data-kg-search-open]");
  var closeTriggers = modal.querySelectorAll("[data-kg-search-close]");
  var viewAllIcon = modal.getAttribute("data-kg-search-view-all-icon") || "";
  var debounceTimer = null;
  var activeController = null;
  var lastFocused = null;

  function formatMoney(cents) {
    if (cents == null || cents === "" || isNaN(Number(cents))) return "";
    var value = Math.round(Number(cents) / 100);
    return "₹" + value.toLocaleString("en-IN");
  }

  function formatCompare(cents) {
    if (cents == null || cents === "" || isNaN(Number(cents))) return "";
    var value = Math.round(Number(cents) / 100);
    return value.toLocaleString("en-IN");
  }

  function parseMoneyValue(value) {
    if (value == null || value === "") return null;
    if (typeof value === "number") return value;
    var cleaned = String(value).replace(/[^\d.]/g, "");
    if (!cleaned) return null;
    var num = Number(cleaned);
    if (isNaN(num)) return null;
    // Predictive search often returns rupees as a decimal string (e.g. "20999.00")
    // while some payloads use cents as integers. Prefer treating decimals as rupees.
    if (String(value).indexOf(".") !== -1 || num < 100000) {
      return Math.round(num * 100);
    }
    return Math.round(num);
  }

  function titleCaseQuery(query) {
    return String(query || "")
      .trim()
      .split(/\s+/)
      .map(function (word) {
        if (!word) return "";
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) {
      el.setAttribute("hidden", "");
    } else {
      el.removeAttribute("hidden");
    }
  }

  function showEmpty() {
    setHidden(emptyEl, false);
    setHidden(resultsEl, true);
    setHidden(statusEl, true);
    if (resultsEl) resultsEl.innerHTML = "";
  }

  function showStatus(message) {
    setHidden(emptyEl, true);
    setHidden(resultsEl, true);
    setHidden(statusEl, false);
    if (statusEl) statusEl.textContent = message;
  }

  function showResults(html) {
    setHidden(emptyEl, true);
    setHidden(statusEl, true);
    setHidden(resultsEl, false);
    if (resultsEl) resultsEl.innerHTML = html;
  }

  function openModal() {
    if (modal.getAttribute("aria-hidden") === "false") {
      input && input.focus();
      return;
    }
    lastFocused = document.activeElement;
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("kg-search-open");
    showEmpty();
    if (input) {
      input.value = "";
      window.setTimeout(function () {
        input.focus();
      }, 10);
    }
  }

  function closeModal() {
    if (modal.getAttribute("aria-hidden") !== "false") return;
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("kg-search-open");
    if (activeController) {
      activeController.abort();
      activeController = null;
    }
    if (debounceTimer) {
      window.clearTimeout(debounceTimer);
      debounceTimer = null;
    }
    showEmpty();
    if (input) input.value = "";
    if (lastFocused && typeof lastFocused.focus === "function") {
      lastFocused.focus();
    }
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function productImage(product) {
    if (!product) return "";
    if (product.image) return product.image;
    if (product.featured_image) {
      if (typeof product.featured_image === "string") return product.featured_image;
      if (product.featured_image.url) return product.featured_image.url;
    }
    if (product.media && product.media[0] && product.media[0].preview_image) {
      return product.media[0].preview_image.src || "";
    }
    return "";
  }

  function buildCard(product) {
    var img = productImage(product);
    var title = escapeHtml(product.title);
    var url = escapeHtml(product.url);
    var priceCents = parseMoneyValue(product.price);
    var compareCents = parseMoneyValue(product.compare_at_price_max || product.compare_at_price);
    var priceLabel =
      typeof product.price === "string" && product.price.indexOf("₹") !== -1
        ? product.price
        : formatMoney(priceCents);

    var compareLabel = "";
    if (compareCents && priceCents && compareCents > priceCents) {
      compareLabel = formatCompare(compareCents);
    } else if (
      typeof product.compare_at_price === "string" &&
      product.compare_at_price &&
      product.compare_at_price !== product.price
    ) {
      compareLabel = String(product.compare_at_price).replace(/[^\d,.]/g, "");
    }

    var imgHtml = img
      ? '<img class="kg-search__result-img" src="' +
        escapeHtml(img) +
        '" alt="" width="77" height="77" loading="lazy">'
      : '<span class="kg-search__result-img kg-search__result-img--placeholder" aria-hidden="true"></span>';

    return (
      '<a class="kg-search__result" href="' +
      url +
      '">' +
      '<span class="kg-search__result-img-wrap">' +
      imgHtml +
      "</span>" +
      '<span class="kg-search__result-meta">' +
      '<span class="kg-search__result-title">' +
      title +
      "</span>" +
      '<span class="kg-search__result-prices">' +
      (priceLabel
        ? '<span class="kg-search__result-price">' + escapeHtml(priceLabel) + "</span>"
        : "") +
      (compareLabel
        ? '<span class="kg-search__result-compare">' + escapeHtml(compareLabel) + "</span>"
        : "") +
      "</span></span></a>"
    );
  }

  function buildResults(products, query) {
    if (!products || !products.length) {
      showStatus("No products found for “" + query + "”");
      return;
    }

    var limited = products.slice(0, 6);
    var heading = "Results for " + titleCaseQuery(query);
    var searchUrl =
      (form && form.getAttribute("action") ? form.getAttribute("action") : "/search") +
      "?q=" +
      encodeURIComponent(query);

    var html =
      '<p class="kg-search__results-heading">' +
      escapeHtml(heading) +
      "</p>" +
      '<div class="kg-search__results-wrap">' +
      '<div class="kg-search__grid">' +
      limited.map(buildCard).join("") +
      "</div>" +
      '<div class="kg-search__footer">' +
      '<a class="kg-search__view-all" href="' +
      escapeHtml(searchUrl) +
      '">' +
      "<span>View all results</span>" +
      (viewAllIcon
        ? '<img class="kg-search__view-all-icon" src="' +
          escapeHtml(viewAllIcon) +
          '" alt="" width="18" height="18">'
        : "") +
      "</a></div></div>";

    showResults(html);
  }

  function fetchSuggestions(query) {
    if (activeController) activeController.abort();
    activeController = typeof AbortController !== "undefined" ? new AbortController() : null;

    var url =
      "/search/suggest.json?q=" +
      encodeURIComponent(query) +
      "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";

    showStatus("Searching…");

    fetch(url, {
      credentials: "same-origin",
      signal: activeController ? activeController.signal : undefined,
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Search failed");
        return res.json();
      })
      .then(function (data) {
        var products =
          (data &&
            data.resources &&
            data.resources.results &&
            data.resources.results.products) ||
          [];
        buildResults(products, query);
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        showStatus("Unable to search right now. Please try again.");
      });
  }

  function onQueryChange() {
    var query = (input && input.value ? input.value : "").trim();
    if (debounceTimer) window.clearTimeout(debounceTimer);

    if (!query) {
      if (activeController) activeController.abort();
      showEmpty();
      return;
    }

    debounceTimer = window.setTimeout(function () {
      fetchSuggestions(query);
    }, 250);
  }

  openTriggers.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      openModal();
    });
  });

  closeTriggers.forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      closeModal();
    });
  });

  if (input) {
    input.addEventListener("input", onQueryChange);
  }

  if (form) {
    form.addEventListener("submit", function (e) {
      var query = (input && input.value ? input.value : "").trim();
      if (!query) {
        e.preventDefault();
        showEmpty();
      }
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.getAttribute("aria-hidden") === "false") {
      e.preventDefault();
      closeModal();
    }
  });
});
